import React from 'react';
import cn from 'classnames';
import { useRegistrationControllers } from '../../../../services/acceptanceRegistration';
import Btn, { btnTypes } from '../../../../../../components/btn';
import { detailsPageModeMap } from '../../../../shared/configs/searchParams';
import styles from './index.module.scss';

const registrationModeTexts = {
  [detailsPageModeMap.registration]: 'Выйти из режима записи',
  [detailsPageModeMap.reRegistration]: 'Выйти из режима перезаписи',
};

const ExitRegistrationMode = ({ pageMode, className }) => {
  const { reset } = useRegistrationControllers();

  const handleClick = (e) => {
    e.stopPropagation();
    reset();
  };

  return (
    <Btn
      type={btnTypes.primary}
      onClick={handleClick}
      className={cn(styles.root, className)}
    >
      {registrationModeTexts[pageMode] ?? ''}
    </Btn>
  );
};

export default ExitRegistrationMode;
